import React from "react";
import { FaWhatsapp, FaPhone } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { indiaSupport } from "../../content/indiaSiteContent";

const SupportCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-brand-dark py-16">
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://storage.googleapis.com/uxpilot-auth.appspot.com/0dcaeedff9-2b4b3f4ceeddc16491b7.png')",
          }}
        />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-6 font-heading text-3xl font-bold text-white md:text-4xl">
          {t("Need help with your application?")}
        </h2>

        <p className="mb-8 text-lg text-gray-400">
          Our visa support team is available 24/7 to guide you through the
          process and answer destination-specific questions.
        </p>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={indiaSupport.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-brand-pink px-8 py-4 font-medium text-white transition-colors hover:bg-brand-pink/90 sm:w-auto"
          >
            <FaWhatsapp className="text-xl" />
            {t("Chat on WhatsApp")}
          </a>

          <a
            href={indiaSupport.phoneHref}
            className="flex w-full items-center justify-center gap-2 rounded-full border border-white/20 px-8 py-4 font-medium text-white transition-colors hover:bg-white/10 sm:w-auto"
          >
            <FaPhone />
            {indiaSupport.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SupportCTA;
